let locationsData = [
 {
  shopId: 'sushidon',
  id: 'sushidon',
  instagram: "sushi_.yu",
  basePath: "/valley-village", 
  cssGlobalPrefix: 'pablitoschicken dark-mode',
  mapLogo: 'https://afag.imgix.net/sushi-don/icon.png?w=250&auto=format',
  // disabled: true, openingDate: "visit/call to order",
  label: "Valley Village",
  className: 'night',
  address: ["4816 Laurel Canyon Blvd", "Valley Village, CA 91607"],
  phone: "(818) 762-8720",
  phoneLink: "+18187628720",
  orderLink: "/valley-village/order",
  lat: 34.1580313, lng: -118.3963859,
  storefrontPhoto: "https://afag.imgix.net/sushi-don/store.png?w=600&auto=format",
  hours: [
    { day: 'Mon-Sat', hours: '11:30am-3pm 4pm-8:30pm' },
    { day: 'Sunday', hours: '12pm-7pm' },
  ]},
];


const siteData = {
  siteLogo: "https://d2abh92eaqfsaa.cloudfront.net/image/upload/c_fill,h_400/qlz8yjyeecmkukeftmqh",
  domain: "sushidonla.com",
  name: "Sushi Don | Order Delivery & Takeout",
  shortName: "Sushidon",
  description: "Valley Village's best kept secret. High quality sushi at unbeatable prices! Combos and specials perfect for lunch or dinner; feed the whole office!",
  folderId: 'sushidonnew',
  ogImage: "https://afag.imgix.net/sushi-don/combo-a.avif?w=600&auto=format",
  iconRoot: 'https://afag.imgix.net/sushi-don/icon.png?w=250&auto=format',
}

export { siteData };
export default locationsData;

